const OPEN_CAMPGROUNDS_GATEWAY_BASEURL = 'https://2xqdp2wveg.execute-api.us-east-2.amazonaws.com/default'

export const onboardNewCustomer = async (firstName, lastName, emailId, password, phoneNumber, username, businessName, businessPhoneNumber,
    businessEmailAddress, address, city, stateRegion, postalCode, country, website, locations, sites, businessType, annualVolume,
    subscription, integratedPayments, amount, perMonth, discountpercentage, discountedAmount) => {

    const requestBody = {
        'operationName': 'onboardNewCustomer',
        'payload': {
            'firstName': firstName,
            'lastName': lastName,
            'emailId': emailId,
            'password': password,
            'phoneNumber': parseInt(phoneNumber),
            'username': username,
            'businessName': businessName,
            'businessPhoneNumber': parseInt(businessPhoneNumber),
            'businessEmailAddress': businessEmailAddress,
            'address': address,
            'city': city,
            'stateRegion': stateRegion,
            'postalCode': parseInt(postalCode),
            'country': country,
            'website': website,
            'locations': parseInt(locations),
            'sites': parseInt(sites),
            'businessType': businessType,
            'annualVolume': parseInt(annualVolume),
            'subscription': subscription,
            'integratedPayments': integratedPayments,
            'amount': amount,
            'perMonthRate': perMonth,
            'discountedPercentage': parseInt(discountpercentage),
            'discountedAmount': parseInt(discountedAmount)
        }
    };

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody)
    };

    try {
        let response = await fetch(OPEN_CAMPGROUNDS_GATEWAY_BASEURL, options);
        let json = await response.json();
        console.log('Onboarded new customer in Open_Campgrounds', json);
        return json;
    } catch (err) {
        console.error('Error while onboarding new customer', err);
    }
}

export const sendEmail = async (firstName, emailId, subscription) => {

    const requestBody = {
        service_id: 'opencampground',
        template_id: 'signup_confirmation',
        user_id: 'n_nqyCHHfHHmQqctU',
        template_params: {
            'customer_name': firstName,
            'subscription': subscription,
            'customer_email': emailId,
        }
    };
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody)
    };
    try {
        let response = await fetch('https://api.emailjs.com/api/v1.0/email/send', options);
        console.log("response from emailjs: ", response)
        return response;
    } catch (err) {
        console.error('Error while storing card.', err);
    }
}

export const sendEmailToBrent = async (firstName, lastName, emailId, password, phoneNumber, username, businessName, businessPhoneNumber,
    businessEmailAddress, address, city, stateRegion, postalCode, country, website, locations, sites, businessType, annualVolume,
    subscription, integratedPayments, amount, perMonth, discountpercentage, discountedAmount) => {

    const requestBody = {
        service_id: 'opencampground',
        template_id: 'email_to_brent',
        user_id: 'n_nqyCHHfHHmQqctU',
        template_params: {
            'firstName': firstName,
            'lastName': lastName,
            'emailId': emailId,
            'password': password,
            'phoneNumber': parseInt(phoneNumber),
            'username': username,
            'businessName': businessName,
            'businessPhoneNumber': parseInt(businessPhoneNumber),
            'businessEmailAddress': businessEmailAddress,
            'address': address,
            'city': city,
            'stateRegion': stateRegion,
            'postalCode': parseInt(postalCode),
            'country': country,
            'website': website,
            'locations': parseInt(locations),
            'sites': parseInt(sites),
            'businessType': businessType,
            'annualVolume': parseInt(annualVolume),
            'subscription': subscription,
            'integratedPayments': integratedPayments,
            'amount': amount,
            'perMonthRate': perMonth,
            'discountedPercentage': parseInt(discountpercentage),
            'discountedAmount': parseInt(discountedAmount)
        }
    };
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody)
    };
    try {
        let response = await fetch('https://api.emailjs.com/api/v1.0/email/send', options);
        console.log("response from emailjs: ", response)
        return response;
    } catch (err) {
        console.error('Error while storing card.', err);
    }
}